import { Page } from '@/components/layout/page/page.tsx'
import { Skeleton } from '@/components/ui/skeleton.tsx'

export const EditRebillMessagesPageSkeleton = () => {
  return (
    <Page>
      <div className="flex flex-col gap-[40px]">
        <Skeleton className="mb-2 h-[100px] w-full animate-pulse rounded-lg bg-skeleton" />
        <Skeleton className="mb-2 h-[100px] w-full animate-pulse rounded-lg bg-skeleton" />
        <Skeleton className="mb-2 h-[400px] w-full animate-pulse rounded-lg bg-skeleton" />
      </div>
    </Page>
  )
}
